import React, { useState, useEffect } from "react";
import { producaov2 as api } from "../../../../services/apis";
import * as yup from "yup";
import { Button, Checkbox, Form, Input, Loader } from "semantic-ui-react";

import { Container, Content, Title, InputColor } from "./styles";

import swal from "sweetalert";
import { Link, withRouter } from "react-router-dom";
import AdminMenu from "../../../../components/Admin/MenuDetalhes/AdminMenu";
import { isAuthAdmin } from "../../../../services/auth";

const FaixaBlog = (props) => {
  const [faixa, setFaixa] = useState();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadAuth();
    api
      .get(`/blog/faixa`)
      .then((res) => {
        setFaixa(res.data);
        setLoading(false);
      })
      .catch((err) => {
        swal("Não foi possível carregar a Faixa", err, "").then((res) =>
          props.history.push("/")
        );
      });
  }, []);

  const loadAuth = async () => {
    const auth = await isAuthAdmin();

    if (!auth) {
      localStorage.setItem("redirect", `/admin/`);
      window.location.href = "/login";
      return null;
    }
  };

  const update = async () => {
    const faixaValidation = yup.object().shape({
      cor_faixa: yup
        .string("Necessário que informe o nome do faixa")
        .required("Necessário que informe o nome do faixa"),
      cor_botao: yup
        .string("Necessário que informe o nome do faixa")
        .required("Necessário que informe o nome do faixa"),
      cor_texto: yup
        .string("Necessário que informe o nome do faixa")
        .required("Necessário que informe o nome do faixa"),
      cor_botao_texto: yup
        .string("Necessário que informe o nome do faixa")
        .required("Necessário que informe o nome do faixa"),
      texto_faixa: yup
        .string("Necessário que informe o nome do faixa")
        .required("Necessário que informe o nome do faixa"),
      texto_botao: yup
        .string("Necessário que informe o nome do faixa")
        .required("Necessário que informe o nome do faixa"),
      link: yup
        .string("Necessário que informe o nome do faixa")
        .required("Necessário que informe o nome do faixa"),
    });

    try {
      await faixaValidation.validate(faixa, { abortEarly: true });
      api
        .put(`/blog/faixa`, faixa)
        .then((res) => {
          let logs = { local: "blog/faixa", texto: `editou a faixa (1)` };
          api.post("system_logs", { acao: JSON.stringify(logs) });
          swal("Faixa alterada com sucesso", "", "success");
        })
        .catch((err) => {
          swal("Não foi possível salvar a faixa", err, "");
        });
    } catch (err) {
      if (err instanceof yup.ValidationError) {
        swal("Erro!", `${err}`, "error");
        return;
      }
    }
  };

  return (
    <>
      <Container>
        <AdminMenu />

        {loading ? (
          <Loader active inline="centered" size="massive" />
        ) : (
          <Content>
            <Title>Editar Faixa do Blog</Title>

            <Form.Group widths="equal">
              <Form.Field
                control={Input}
                label="Ativo (0 | 1)"
                placeholder="Ativo"
                value={faixa.ativo}
                onChange={(e) => {
                  setFaixa({ ...faixa, ativo: e.target.value });
                }}
              />
            </Form.Group>

            <Form>
              <Form.Group widths="equal">
                <Form.Field
                  control={InputColor}
                  label="Cor da Faixa"
                  placeholder="Cor da Faixa"
                  type="color"
                  value={faixa.cor_faixa}
                  onChange={(e) => {
                    setFaixa({ ...faixa, cor_faixa: e.target.value });
                  }}
                />
                <Form.Field
                  control={InputColor}
                  label="Cor do botão"
                  placeholder="Cor do botão"
                  type="color"
                  value={faixa.cor_botao}
                  onChange={(e) => {
                    setFaixa({ ...faixa, cor_botao: e.target.value });
                  }}
                />
                <Form.Field
                  control={InputColor}
                  label="Cor do Texto"
                  placeholder="Cor do Texto"
                  type="color"
                  value={faixa.cor_texto}
                  onChange={(e) => {
                    setFaixa({ ...faixa, cor_texto: e.target.value });
                  }}
                />
                <Form.Field
                  control={InputColor}
                  label="Cor do texto do botão"
                  placeholder="Cor do texto do botão"
                  type="color"
                  value={faixa.cor_botao_texto}
                  onChange={(e) => {
                    setFaixa({ ...faixa, cor_botao_texto: e.target.value });
                  }}
                />
              </Form.Group>

              <Form.Group widths="equal">
                <Form.Field
                  control={Input}
                  label="Texto Faixa"
                  placeholder="Texto Faixa"
                  value={faixa.texto_faixa}
                  onChange={(e) => {
                    setFaixa({ ...faixa, texto_faixa: e.target.value });
                  }}
                />
              </Form.Group>

              <Form.Group widths="equal">
                <Form.Field
                  control={Input}
                  label="Texto Botão"
                  placeholder="Texto Botão"
                  value={faixa.texto_botao}
                  onChange={(e) => {
                    setFaixa({ ...faixa, texto_botao: e.target.value });
                  }}
                />
              </Form.Group>

              <Form.Group widths="equal">
                <Form.Field
                  control={Input}
                  label="Link (se não tiver nada, coloque #)"
                  placeholder="Link"
                  value={faixa.link}
                  onChange={(e) => {
                    setFaixa({ ...faixa, link: e.target.value });
                  }}
                />
              </Form.Group>

              <Form.Group>
                <Form.Field control={Button} onClick={() => update()}>
                  Salvar
                </Form.Field>
                <Link to="/admin">
                  <Button color="secondary">Cancelar</Button>
                </Link>
              </Form.Group>
            </Form>
          </Content>
        )}
      </Container>
    </>
  );
};

export default withRouter(FaixaBlog);
